export enum OrderCompletionProgress {
    None = 1,
    LessOrEqualHalf = 2,
    MoreThanHalf = 3,
    Completed = 4
}
